import { gql } from "@apollo/client";

export const GET_DISPLAY_PROJECTS = gql`
  query GetDisplayProjects {
    home_page_project {
      id
      title
      image
      link
      client_img
      location
      sector
      introduction
      showcase
      separate_bg
    }
  }
`;

export const INSERT_PROJECT = gql`
  mutation InsertProject($object: home_page_project_insert_input!) {
    insert_home_page_project_one(object: $object) {
      id
      title
      image
      link
      client_img
      location
      sector
      introduction
      showcase
      separate_bg
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($id: uuid!, $object: home_page_project_set_input!) {
    update_home_page_project_by_pk(pk_columns: { id: $id }, _set: $object) {
      id
      title
      image
      link
      client_img
      location
      sector
      introduction
      showcase
      separate_bg
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: uuid!) {
    delete_home_page_project_by_pk(id: $id) {
      id
    }
  }
`;
